module.exports = __webpack_public_path__ + "static/img/2areaA_55.626333a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/2areaA_55.png
// module id = 1022
// module chunks = 1